<template>
  <a-form
    ref="ruleForm"
    :rules="rules"
    :model="form"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :layout="layout"
  >
   <a-form-item label="Mã địa điểm" name="code">
      <a-input v-model:value="form.code"  placeholder="Vui lòng nhập mã địa điểm"/>
    </a-form-item>
    <a-form-item label="Tên địa điểm" name="title">
      <a-input v-model:value="form.title"  placeholder="Vui lòng nhập tên địa điểm"/>
    </a-form-item>
    <a-form-item label="Tỉnh/Thành phố" name="province">
      <o-select
        ref="province"
        v-model:value="form.province"
        @input="onChangeProvince"
        placeholder="Vui lòng chọn tỉnh/thành phố"
        entity="province"
        :title="'Tỉnh/Thành phố'"
        :icon="'environment'"
        :isDisplay="'none'"
        :isDisplayAdd="'none'"
      />
    </a-form-item>
    <a-form-item label="Quận/Huyện" name="district">
      <o-select
        ref="district"
        v-model:value="form.district"
        @input="onChangeDistrict"
        placeholder="Vui lòng chọn quận/huyện"
        entity="district"
        :disabled="districtDisabled"
        :title="'Quận/Huyện'"
        :icon="'environment'"
        :isDisplay="'none'"
      />
    </a-form-item>
    <a-form-item label="Phường/Xã" name="ward">
      <o-select
        ref="ward"
        v-model:value="form.ward"
        @input="form.ward = $event"
        placeholder="Vui lòng chọn phường/xã"
        entity="ward"
        :disabled="wardDisabled"
        :title="'Phường/Xã'"
        :icon="'environment'"
        :isDisplay="'none'"
      />
    </a-form-item>
    <a-form-item label="Địa chỉ" name="address">
          <a-input
            v-model:value="form.address"
            placeholder="Vui lòng nhập địa chỉ"
          />
        </a-form-item>
  </a-form>
</template>
<script >
import OneLogSelect from "@/components/Select/OneLogSelect";
import formUtility from "@/formUtility";
import { defineComponent } from "vue";

export default defineComponent({
  mixins: [formUtility],
  components: {
    "o-select": OneLogSelect,
  },
  props: {
    formData: {},
    width: String,
  },
  data() {
    let validateProvince = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject("Vui lòng Tỉnh/Thành Phố");
      } else {
        return Promise.resolve();
      }
    };
    let validateWard = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject("Vui lòng Xã/Phường");
      } else {
        return Promise.resolve();
      }
    };
    let validateDistrict = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject("Vui lòng Quận/Huyện");
      } else {
        return Promise.resolve();
      }
    };
    const fields = [
      { name: "title", required: true, min: 0, max: 250 },
      {
        name: "province",
        validator: validateProvince,
        trigger: ["change", "blur"],
        required: true,
      },
      {
        name: "district",
        validator: validateDistrict,
        trigger: ["change", "blur"],
      },
      {
        name: "ward",
        validator: validateWard,
        trigger: ["change", "blur"],
      },
    ];
    let rules = this.generateRules("Location", fields);
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      layout: "horizontal",
      form: this.formData,
      rules,
      districtDisabled: true,
      wardDisabled: true,
    };
  },
  methods: {
    onChangeProvince($event) {
      this.form.province = $event;
      let item = this.$refs.district;

      this.districtDisabled = typeof $event == "undefined";
      this.form.district = void 0;

      this.wardDisabled = true;
      this.form.ward = void 0;

      this.onChangeLocation($event, item, "province_id");
    },
    onChangeDistrict($event) {
      this.form.district = $event;
      let item = this.$refs.ward;
      this.wardDisabled = typeof $event == "undefined";
      this.form.ward = void 0;
      this.onChangeLocation($event, item, "district_id");
    },
    onChangeLocation($event, item, field) {
      let value = $event ? $event.key : void 0;
      item.onLoad({ field, value });
    },
  },
});
</script>
<style scoped>
.ant-form-item {
  margin-bottom: 12px;
}
</style> 